import React from "react";

/**
 * Shown when the backend returns 403 for an API call.
 * message — the 403 message from the server
 * required — the api key that was missing
 */
const AccessDenied = ({ message, required }) => (
  <div style={{
    display: "flex", flexDirection: "column", alignItems: "center",
    justifyContent: "center", padding: "60px 40px", textAlign: "center",
  }}>
    <div style={{
      width: 72, height: 72, borderRadius: "50%",
      background: "#fee2e2", display: "flex", alignItems: "center",
      justifyContent: "center", marginBottom: 20,
    }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="#dc2626" viewBox="0 0 16 16">
        <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2m3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2"/>
      </svg>
    </div>
    <h3 style={{ margin: "0 0 8px", fontSize: 20, fontWeight: 700, color: "#111" }}>
      Access Denied
    </h3>
    <p style={{ margin: "0 0 6px", color: "#666", fontSize: 14, maxWidth: 360 }}>
      {message || "You do not have permission to access this resource."}
    </p>
    {required && (
      <p style={{ margin: 0, color: "#aaa", fontSize: 12 }}>
        Required permission: <code style={{ background: "#f3f4f6", padding: "1px 6px", borderRadius: 4 }}>{required}</code>
      </p>
    )}
  </div>
);

export default AccessDenied;
